import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  ArrowBack as ArrowBackIcon,
  Apps as AppsIcon,
  YoutubeSearchedFor as WebsiteAnalyserIcon,
  ImageSearch as AdRenderersIcon,
  TextFields as KeywordIcon,
  LiveTvOutlined as CtvIcon,
  Assessment as BidRequestIcon,
  OpenInBrowser as UrlOpenerIcon,
  CallMerge as TextMergerIcon,
  VerifiedUser as ValidatorIcon,
  CloudDownload as ExporterIcon,
  Domain as DomainsIcon,
  PhoneAndroid as BundlesIcon,
  BugReport as SqtaIcon,
  Explore as ExperimentsIcon,
  Build as MiscIcon,
  AccountTree as VerticalizeIcon,
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./Components/SidebarLink/SidebarLink";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../Context/LayoutContext";

const structure = [
  { id: 0, type: "title", label: "ANALYSIS" },
  { id: 1, label: "Verticalization", link: "/app/appanalyser", icon: <VerticalizeIcon /> },
  { id: 2, label: "App Analyser 2.0", link: "/app/appanalyser2", icon: <AppsIcon /> },
  { id: 3, label: "Website Analyser", link: "/app/websiteanalyser", icon: <WebsiteAnalyserIcon /> },
  { id: 4, label: "CTV Analyser", link: "/app/ctvanalyser", icon: <CtvIcon /> },
  { id: 5, label: "Keyword Checker", link: "/app/keywordchecker", icon: <KeywordIcon /> },

  { id: 6, type: "divider" },
  { id: 7, type: "title", label: "ADVERTISING" },
  { id: 8, label: "Ad Renderers", link: "/app/adrenderers", icon: <AdRenderersIcon /> },
  { id: 9, label: "Bid Request Analyser", link: "/app/bidrequestsanalyser", icon: <BidRequestIcon /> },

  { id: 10, type: "divider" },
  { id: 11, type: "title", label: "UTILITIES" },
  { id: 12, label: "URL Opener", link: "/app/urlopener", icon: <UrlOpenerIcon /> },
  { id: 13, label: "Text Merger", link: "/app/textmerger", icon: <TextMergerIcon /> },
  { id: 14, label: "Miscellaneous", link: "/app/miscellaneous", icon: <MiscIcon /> },

  { id: 15, type: "divider" },
  { id: 16, type: "title", label: "COMPLIANCE" },
  { id: 17, label: "Sellers.json Validator", link: "/app/sellerjsonvalidator", icon: <ValidatorIcon /> },
  { id: 18, label: "Sellers.json Exporter", link: "/app/sellersjsonexporter", icon: <ExporterIcon /> },
  { id: 19, label: "Approved Domains", link: "/app/approved", icon: <DomainsIcon /> },
  { id: 20, label: "Approved Bundles", link: "/app/approvedbundles", icon: <BundlesIcon /> },

  { id: 21, type: "divider" },
  { id: 22, type: "title", label: "OTHER" },
  { id: 23, label: "SQTA", link: "/app/sqta", icon: <SqtaIcon /> },
  { id: 24, label: "Experiments", link: "/app/experiments", icon: <ExperimentsIcon /> },
];

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
